import {Pipe, PipeTransform} from '@angular/core';
import {ChangelogItem} from '../../../@backend/modules/@documentation/models/changelog-item.model';

@Pipe({
  name: 'logItemNonZero'
})
export class LogItemNonZeroPipe implements PipeTransform {

  transform(log: ChangelogItem[], category: string, draftVisible: boolean): boolean {
    return log.filter((a) => draftVisible ? a.category === category : (a.category === category && a.status === 'PUBLISHED')).length > 0;
  }

}
